import {
  alpha,
  Box,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import { GetApp, InsertDriveFile } from '@material-ui/icons';
import clsx from 'clsx';
import fileSize from 'filesize';

import InfiniteScroll from 'components/InfiniteScroll';
import { MidiasContatoInterface } from 'store/reducers/contatos';

const SCROLL_CONTAINER_ID = 'scrollableDocumentosContato';

const useStyles = makeStyles(({ palette, spacing }) => ({
  paper: {
    width: '100%',
    padding: 0,
    border: `1px solid transparent`,
    backgroundColor: alpha(palette.action.disabledBackground, 0.05),
    transition: 'all 0.1s ease',

    '&:hover': {
      backgroundColor: alpha(palette.primary.main, 0.1),
      border: `1px solid ${alpha(palette.primary.main, 0.2)}`,
      cursor: 'pointer',
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  list: {
    height: '100%',
    overflow: 'auto',
    padding: spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
  },
  listItemIcon: {
    width: 40,
    height: 40,
    borderRadius: 99,
    backgroundColor: palette.action.selected,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface ListaDocumentosContatoProps {
  documentos: MidiasContatoInterface[];
  loading: boolean;
  hasMore: boolean;
  loadMore: () => void;
}

export default function ListaDocumentosContato(
  props: ListaDocumentosContatoProps,
) {
  const { documentos, loading, hasMore, loadMore } = props;

  const classes = useStyles();

  const renderDocumento = (midia: MidiasContatoInterface) => {
    const { url, size, title, filename } = midia;
    return (
      <Paper
        elevation={0}
        className={clsx(classes.paper)}
        key={midia.id || midia.filename || midia.url}
      >
        <ListItem className={classes.content}>
          <ListItemAvatar>
            <Box className={classes.listItemIcon}>
              <InsertDriveFile color="inherit" />
            </Box>
          </ListItemAvatar>

          <ListItemText
            title={title}
            primary={filename || title || 'Documento'}
            primaryTypographyProps={{ noWrap: true, variant: 'body2' }}
            secondary={`Tamanho - ${
              fileSize(size, { round: 0, locale: 'pt-BR' }) || 0
            } `}
            secondaryTypographyProps={{ noWrap: true, variant: 'caption' }}
          />

          <Box ml={1}>
            <Link rel="noopener noreferrer" href={`${url}?download=true`}>
              <IconButton title="Baixar">
                <GetApp />
              </IconButton>
            </Link>
          </Box>
        </ListItem>
      </Paper>
    );
  };

  const renderDocumentosContato = () => {
    return (
      <List id="scrollableDocumentosAtendimento" className={classes.list}>
        {documentos.map(midia => renderDocumento(midia))}
      </List>
    );
  };
  return (
    <List
      id="scrollableDocumentosContato"
      style={{
        height: '100%',
        overflow: 'auto',
        padding: 0,
      }}
    >
      <InfiniteScroll
        data={documentos}
        next={loadMore}
        scrollableTarget={SCROLL_CONTAINER_ID}
        hasMore={hasMore}
        loading={loading}
      >
        {!loading && documentos.length === 0 && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={80}
          >
            <Typography variant="body2" color="textSecondary">
              Nenhum documento foi encontrado.
            </Typography>
          </Box>
        )}

        {renderDocumentosContato()}
      </InfiniteScroll>
    </List>
  );
}
